export default __webpack_public_path__ + "static/media/Breach_Aftershock.26e9cea1.png";